"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportTab = exports.reportRenderingReset = exports.reportRendering = exports.reportRenderSuccess = exports.reportRenderError = exports.reportLatest = exports.reportGoToFund = void 0;
var _reportRendering = require("./reportRendering.constant");
// @flow

// common success
var reportRenderSuccess = function reportRenderSuccess(actionType, data) {
  return {
    type: _reportRendering.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportRenderSuccess = reportRenderSuccess;
var reportRenderError = function reportRenderError(actionType, error) {
  return {
    type: _reportRendering.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * report html
 * @param payload
 * @returns api response
 * @description this function used to fetch report html.
 */
exports.reportRenderError = reportRenderError;
var reportRendering = function reportRendering(payload) {
  return {
    type: _reportRendering.actionTypes.REPORT_RENDERING,
    payload: payload
  };
};

/**
 * report html
 * @param payload
 * @returns api response
 * @description this function used to fetch report html.
 */
exports.reportRendering = reportRendering;
var reportLatest = function reportLatest(payload) {
  return {
    type: _reportRendering.actionTypes.REPORT_LATEST,
    payload: payload
  };
};

/**
 * report html
 * @param payload
 * @returns api response
 * @description this function used to fetch report html of particular fund.
 */
exports.reportLatest = reportLatest;
var reportGoToFund = function reportGoToFund(payload) {
  return {
    type: _reportRendering.actionTypes.REPORT_GO_TO_FUND,
    payload: payload
  };
};

/**
 * report tab
 * @param payload
 * @returns api response
 * @description this function used to fetch report tab.
 */
exports.reportGoToFund = reportGoToFund;
var reportTab = function reportTab(payload) {
  return {
    type: _reportRendering.actionTypes.REPORT_TAB,
    payload: payload
  };
};

/**
 * Reset report rendering
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
exports.reportTab = reportTab;
var reportRenderingReset = function reportRenderingReset(payload) {
  return {
    type: _reportRendering.actionTypes.REPORT_RENDERING_RESET,
    payload: payload
  };
};
exports.reportRenderingReset = reportRenderingReset;